import React, { FC } from 'react'
import { ArtistAvatar } from 'components'
import styles from './ProjectDetail.module.scss'
import { IProjectDetail } from './ProjectDetail.props'

export const ProjectDetail: FC<IProjectDetail> = ({ facebookId = '', spotifyId = '', children }) => (
  <div className={styles.container}>
    <ArtistAvatar
      className="artist-preview__avatar"
      facebookId={facebookId}
      spotifyId={spotifyId}
      size="s"
      isImage
    />
    <div className={styles.side}>
      {children}
    </div>
  </div>
)